import * as yup from 'yup';
import {
  addressSchema,
  stakeIpSchema,
  stakeIpv6Schema,
  stakePortSchema,
} from './schema';

const updateValidatorInfoRequestSchema = yup.object({
  ip: stakeIpSchema,
  ipv6: stakeIpv6Schema,
  port: stakePortSchema,
  nodeAddress: addressSchema,
});

export default class UpdateValidatorInfoRequest {
  public readonly ip: string;
  public readonly ipv6: string;
  public readonly port: string;
  public readonly nodeAddress: string;

  constructor({
    ip,
    ipv6,
    port,
    nodeAddress,
  }: {
    ip: string;
    ipv6: string;
    port: string;
    nodeAddress: string;
  }) {
    this.ip = ip;
    this.ipv6 = ipv6;
    this.port = port;
    this.nodeAddress = nodeAddress;
  }

  async validate(): Promise<void> {
    try {
      await updateValidatorInfoRequestSchema.validate({
        ip: this.ip,
        ipv6: this.ipv6,
        port: this.port,
        nodeAddress: this.nodeAddress,
      });
    } catch (e: any) {
      throw new Error(`Invalid update validator info request: ${e.message}`);
    }
  }
}
